import React, { forwardRef, useEffect, useImperativeHandle, useRef } from "react";

import InputFieldComponents from "components/InputFieldComponents/InputFieldComponents";
import { IInputFieldWithValidationProps } from "components/InputFieldWithValidation";
import DecoratedInputField from "components/InputFieldComponents/DecoratedInputField";


type CheckboxProps = Omit<IInputFieldWithValidationProps, "type"> & {
  pure?: boolean,
  indeterminate?: boolean,
};

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  function (
    {
      labelPosition = "right",
      pure = false,
      indeterminate,
      ...props
    }: CheckboxProps,
    ref
  ) {
    const checkboxRef = useRef<HTMLInputElement>(null);
    useImperativeHandle(ref, () => checkboxRef.current!, []);

    useEffect(() => {
      if (checkboxRef.current) {
        checkboxRef.current.indeterminate = indeterminate === true;
      }
    }, [ indeterminate ]);

    // TODO the default checkbox component is a bit off as it has a wider focus outline. need to figure out how to change
    //  that properly to match the focus outlines of other inputs, otherwise it's either off-grid in its normal state, or
    //  off in its focused state :(
    if (pure) {
      return (
        <DecoratedInputField
          ref={ checkboxRef }
          { ...props }
          type="checkbox"
        />
      )
    } else {
      return (
        <InputFieldComponents
          ref={ checkboxRef }
          { ...props }
          labelPosition={ labelPosition }
          type="checkbox"
        />
      );
    }
  }
);

export default Checkbox;
